export const SETTING_SLICE_NAME = "setting"
